import { OptionType } from '@components/Select';

export const CUSTOM_OPTION_VALUE = 'customOptionValue';

export function makeCustomOption(value: string): OptionType<string> {
    return {
        label: value,
        value: `${CUSTOM_OPTION_VALUE}_${value}`,
    };
}
